
 

 

 

 
class UserCriteria01 
{
    
        Code: string;
    
        CodeLike: string;
    
        Login: string;
    
        LoginLike: string;
    
        UserUID: string;
    
        Name: string;
    
        Email: string;
    
        EmailLike: string;
    
        IsGroup: boolean;
    
        IsActive: boolean;
    
        IsRole: boolean;
    
        Realm: string;
    
        AutoCompleteText: string;
    
        PasswordExpireDate: Date;
    
}
 
export default UserCriteria01;
 

